import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'pixl-consumer-info',
  templateUrl: './consumer-info.component.html',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    TranslocoModule
  ],
  standalone: true,
  styleUrls: ['../form-dialog-consumer.component.scss']
})
export class ConsumerInfoComponent {
  @Input() parentForm!: FormGroup;

  public hasError(controlName: string, errorName: string): boolean {
    const control = this.parentForm.get(controlName);
    return !!control && control.touched && control.hasError(errorName);
  }
}
